exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".announcement_title {\n\tmargin: 10px 0 0;\n    font-size: 22px;\n    color: #3598db;\n    font-weight: 600;\n}\n.active_announcement .date { display: -webkit-box; display: -ms-flexbox; display: flex; color: #999; margin-bottom: 10px; }\n.active_announcement .date span { padding:0 10px 0 0;}\n.announcement_desc { font-size:16px; }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/postcss-loader/lib!./src/app/views/admin/announcements/Announcements.css
// module id = 1901
// module chunks = 0